<template>
  <div>
    <section class="pt-5">
      <b-container class="my-5">
        <h1 class="text-secondary font-weight-bold">My projects</h1>
        <p>Here you can find most of the projects that I have built in the last couple of years.</p>
      </b-container>
    </section>
    <section class="py-5 bg-light">
      <b-container class="py-5">
        <b-row class="pb-5" cols-md="2" cols="1">
          <b-col>
            <img src="@/assets/Logo_viv_nl.png" class="img-fluid" alt />
          </b-col>
          <b-col class="d-flex flex-column">
            <h2 class="text-dark font-weight-bold">Verspilling is Verrukkelijk</h2>
            <p>With a team at school I participated in a project for Verspilling is Verrukkelijk. We built a partial demo webshop which was later completely rebuilt.</p>
            <p>The project involved creating a PostgreSQL database and a Java SpringBoot backend.</p>
            <a class="disabled mt-auto ml-auto mr-3 mb-3" href="#">No github sorry 😭</a>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <round-section-border class="section-border-top" fill="#363636"></round-section-border>
    <section class="bg-dark">
      <b-container class="py-5">
        <b-row cols-md="2" cols="1">
          <b-col>
            <h2 class="text-light font-weight-bold">Eenmaal Andermaal</h2>
            <p
              class="text-light"
            >This was another school project in which we built a website. This time the we were supposed to build an auction website.</p>
            <p class="text-light">The entire website was built with PHP and a MSSQL database.</p>
            <a
              class="mt-auto ml-auto mr-3 mb-3"
              href="https://github.com/WuttiFrutti/i-project-26"
            >Github</a>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-container>
    </section>
    <round-section-border
      class="section-border-bottom"
      :transform="'scale(1,-1) translate(0,-100)'"
      fill="#363636"
    ></round-section-border>
    <section class="pt-5 bg-primary">
      <b-container class="py-5">
        <b-row class="pt-5" cols-md="2" cols="1">
          <b-col></b-col>
          <b-col class="d-flex flex-column">
            <h2 class="text-light font-weight-bold">Scouting Huissen Zand</h2>
            <p
              class="text-light"
            >This is the first full website that I built outside of school. It is also the first full website that I built with the Vue CLI or any JavaScript framework.</p>
            <p
              class="text-light"
            >Even though I would have loved to build a Java or ASP.net backend for the website I didn't as it would be very expensive.
            <br><br> I am currently rebuilding the website in Laravel.
            </p>
            <a
              class="text-secondary mt-auto ml-auto mr-3 mb-3"
              href="https://github.com/WuttiFrutti/ScoutingHuissenZand"
            >Github</a>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <slanted-section-border class="section-border-bottom" fill="#7957d5"></slanted-section-border>
    <section class="py-5">
      <b-container class="my-5 py-5">
        <b-row class="pt-5" cols-md="2" cols="1">
          <b-col>
            <h1 class="mt-5 text-secondary font-weight-bold">Other</h1>
            <p>
              The rest of my projects can be found on my github profile:
              <a class="text-secondary" href="https://github.com/WuttiFrutti">Github</a>
            </p>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <img src="@/assets/github.png" style="max-height:200px" class="img-fluid" alt />
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import SlantedSectionBorder from "@/components/svg/SlantedSectionBorder";
import RoundSectionBorder from "@/components/svg/RoundSectionBorder";

export default {
  components: { SlantedSectionBorder, RoundSectionBorder },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.$emit("navsetting", false));
  }
};
</script>
